import React from "react";

import { ArrowUp, ArrowDown } from "assets";
import { Order } from "types/order.types";

export const orderIcons: Record<Order, React.ReactNode> = {
  asc: <ArrowUp />,
  desc: <ArrowDown />,
};
